import { get5x5ObjectDefinition, getFamilyAddress, getOnePersonWithFriends } from "../Testing/TestData";
import {
    DisplayEditModeTemplate,
    DisplayLayerEditModeTemplate,
    DisplayModeTemplate,
    EditModeTemplate,
    GridTestTemplate,
} from "./CommonStoryTemplates";
import { DataDefinition } from "../../../rule-engine-core/Common/Data/DataDefinition";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { ObjectDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/ObjectDataDefinition";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { NumberDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { StoryNode } from "../../StoryBook/StoryData";
import React from "react";

let griddef = get5x5ObjectDefinition();

let def = new DataDefinition();
let odef = new ObjectDataDefinition("object");
let fdef = new StringDataDefinition("firstName");
let ldef = new StringDataDefinition("lastName");
odef.fields.push(fdef);
odef.fields.push(ldef);
def.fields.push(odef);

DataUtilities.set(def.getValueObject(), odef.name, {
    firstName: "firstName",
    lastName: "lastName",
});

let typeName = "Object";

export const ObjectEditorStories = [
    new StoryNode(
        () => {
            return <GridTestTemplate definition={griddef}></GridTestTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Grid",
    ),
    new StoryNode(
        () => {
            return <DisplayModeTemplate definition={def}></DisplayModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Display Mode",
    ),
    new StoryNode(
        () => {
            return <EditModeTemplate definition={def}></EditModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Edit Mode",
    ),
    new StoryNode(
        () => {
            return <DisplayEditModeTemplate definition={def}></DisplayEditModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Display Edit Mode",
    ),
    new StoryNode(
        () => {
            return <DisplayLayerEditModeTemplate definition={def}></DisplayLayerEditModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Display Layer Edit Mode",
    ),

    new StoryNode(
        () => {
            let def = new DataDefinition();
            odef = new ObjectDataDefinition("object");
            ldef = new StringDataDefinition("lastName");
            let cdef = new StringDataDefinition("Children");
            cdef.list = true;
            odef.fields.push(ldef);
            odef.fields.push(cdef);
            def.fields.push(odef);
            return <DisplayModeTemplate definition={def}></DisplayModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Has Child List Display Mode",
    ),
    new StoryNode(
        () => {
            let def = new DataDefinition();
            odef = new ObjectDataDefinition("object");
            ldef = new StringDataDefinition("lastName");
            let cdef = new StringDataDefinition("Children");
            cdef.list = true;
            odef.fields.push(ldef);
            odef.fields.push(cdef);
            def.fields.push(odef);
            return <EditModeTemplate definition={def}></EditModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Has Child List Edit Mode",
    ),
    new StoryNode(
        () => {
            let def = new DataDefinition();
            let ddef = new ObjectDataDefinition("data");

            // person
            odef = new ObjectDataDefinition("person");
            ldef = new StringDataDefinition("lastName");

            odef.fields.push(ldef);
            ddef.fields.push(odef);

            // children
            let chdef = new ObjectDataDefinition("children");
            chdef.list = true;
            chdef.fields.push(new StringDataDefinition("firstName"));
            chdef.fields.push(new NumberDataDefinition("age"));

            // friends
            let friends = new ObjectDataDefinition("friends");
            friends.fields.push(new StringDataDefinition("firstName"));
            friends.fields.push(new StringDataDefinition("lastName"));

            // friends scores
            let scores = new ObjectDataDefinition("scores");
            let math = new NumberDataDefinition("math");
            let english = new NumberDataDefinition("english");
            scores.fields.push(math);
            scores.fields.push(english);
            friends.fields.push(scores);

            friends.list = true;

            chdef.fields.push(friends);

            ddef.fields.push(chdef);

            // address
            let adef = new ObjectDataDefinition("address");
            let city = new StringDataDefinition("city");
            let street = new StringDataDefinition("street");
            adef.fields.push(city);
            adef.fields.push(street);

            let postalCode = new StringDataDefinition("postalCode");
            adef.fields.push(postalCode);

            ddef.fields.push(adef);

            def.fields.push(ddef);

            return <EditModeTemplate definition={def}></EditModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Has Child Object Edit Mode",
    ),
    new StoryNode(
        () => {
            return <DisplayLayerEditModeTemplate definition={getOnePersonWithFriends()}></DisplayLayerEditModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "One Person With Friends",
    ),
    new StoryNode(
        () => {
            return <DisplayLayerEditModeTemplate definition={getFamilyAddress()}></DisplayLayerEditModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Family Address",
    ),
];
